export default "__VITE_ASSET__DBSrUrGe__"